import React from "react";
import AppStoreBadge from "./AppStoreBadge";
import { art } from "./config";

export default function FinalCTA() {
  return (
    <section className="final" data-testid="final-cta">
      <div className="final-card">
        <h2 className="display rv">
          Come and <span className="said">say hi.</span>
        </h2>
        <p className="lede rv" style={{ "--d": "100ms" }}>
          Download Leo, add your child, and let them have a chat. I'll probably need a bit of help.
        </p>
        <div className="hero-ctas rv" style={{ "--d": "180ms" }}>
          <AppStoreBadge testId="final-app-store" />
        </div>
        <div className="final-leo rv" style={{ "--d": "240ms" }}>
          <span className="wave-bubble">Hiya! Can you help me?</span>
          <img src={art("leo-waving-600.png")} srcSet={`${art("leo-waving-600.png")} 238w, ${art("leo-waving.png")} 357w`} sizes="260px" alt="Leo waving" loading="lazy" />
        </div>
      </div>
    </section>
  );
}
